import { render, staticRenderFns } from "./headRecord.vue?vue&type=template&id=50ba9d6c&scoped=true&"
import script from "./headRecord.vue?vue&type=script&lang=js&"
export * from "./headRecord.vue?vue&type=script&lang=js&"
import style0 from "./headRecord.vue?vue&type=style&index=0&id=50ba9d6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba9d6c",
  null
  
)

export default component.exports